exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.edit-button {\r\n    border-left: 0px;\r\n    width: 39px;\r\n    height: 34px;\r\n}\r\n\r\n.flexContainer {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n\r\n.inputField {\r\n    -ms-flex: 1;\r\n        flex: 1;\r\n    padding-right: 75px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/dropdown-editable/dropdown-editable.component.css
// module id = ../../../../../src/app/shared/dropdown-editable/dropdown-editable.component.css
// module chunks = 16